module.exports = __webpack_public_path__ + "img/refund-type-money.2501f3ae.png";